function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Fast-Tasting",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "1b",
  transform: "translate(-45.000000, -297.000000)",
  stroke: "#391D4D"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-7",
  transform: "translate(46.000000, 298.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.95873109,0 C2.95873109,6.29895209 0,8.65432399 0,12.7749419 C0,17.5549614 4.48692906,19 7,19 C9.51307094,19 14,17.5549614 14,12.7749419 C14,8.65432399 11.0417829,6.46829255 11.0417829,0 L2.95873109,0 Z",
  id: "Stroke-1",
  strokeWidth: 1.85543984
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.5,19 L7.5,28",
  id: "Stroke-3",
  strokeWidth: 2.15999981
}), /*#__PURE__*/React.createElement("path", {
  d: "M15,28.5 L0,28.5",
  id: "Stroke-5",
  strokeWidth: 2.15999981
}))));

var SvgIconWineFortified = function SvgIconWineFortified(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "31px",
    viewBox: "0 0 16 31",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconWineFortified, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-wine-fortified.a72ecc9d.svg";
export { ForwardRef as ReactComponent };